class ThreatBlockerDatatable {
    constructor(){
        let searchParams = new URLSearchParams(window.location.search);
        this.start = searchParams.get('start');
        this.end = searchParams.get('end');
        this.datatable = this.init('#threat-blocker-datatable', searchParams.get('organizationID'));
        this.filterActions();
    }
    init(el, organizationID){
        const datatable =  $(el).DataTable({
            searchDelay: 400,
            processing: true,
            serverSide: true,
            stateSave: false,
            info: true,
            paging: true,
            order: [[3, 'desc']],
            searchCols: [
                null,
                null,
                null,
                { "search": (this.start && this.end ? this.start+' - '+this.end : moment().startOf('isoWeek').format("YYYY-MM-DD hh:mm:ss")+' - '+moment().endOf('isoWeek').format("YYYY-MM-DD hh:mm:ss")), "regex": false }
            ],
            ajax: {
                url: '?do=getThreatBlockerLog',
                type: 'POST',
                data: {
                    organizationID: organizationID,
                }
            },
            language: {
                emptyTable: "No data found"
            },
            dom:
                "<'table-responsive'tr>" +
                "<'row'" +
                "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'li>" +
                "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
                ">",
            drawCallback: function(settings) {
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                //reinit tooltips
                const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
                const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
                // init page length select
                $('select[name=threat-blocker-datatable_length]').select2({minimumResultsForSearch: -1});
            },
            columns: [
                {
                    data: 'uuid',
                    title: 'Member',
                    sortable: true,
                    className: 'min-w-100px',
                    render: function (data, type, row) {
                        if(row['mockData']){
                            let avatarUrl = '/media/goodaccess/avatars/svg/Icon with face-' + row['avatarID'] + '.svg';
                            return '<div class="d-flex align-items-center access-denied">' +
                                '       <div class="symbol symbol-40px me-3 border ga-border-primary-300 symbol-circle">' +
                                '           <div class="symbol-label bg-light-primary border border-2 border-white">' +
                                '               <img src="' + avatarUrl + '" alt="avatar">' +
                                '           </div>' +
                                '       </div>' +
                                '       <div class="d-flex justify-content-start flex-column">' +
                                '           <div><span class="fw-bold text-decoration-underline-ga primary text-primary mb-1 fs-6">' + row['name'] + '</span></div>' +
                                '       </div>' +
                                '   </div>';
                        } else {
                            return new MemberInfoGenerator(row).generateTableMember();
                        }
                    }
                },
                {
                    data: 'domain',
                    title: 'Domain',
                    sortable: true,
                    render: function (data, type, row) {
                        if(row['mockData']){
                            return '<div class="access-denied">'+row['domain']+'</div>';
                        } else {
                            return row['domain'];
                        }
                    }
                },
                {
                    data: 'hits',
                    title: 'Hits',
                    sortable: true,
                    render: function (data, type, row) {
                        return row['hits'];
                    }
                },
                {
                    data: 'time',
                    title: 'Last hit',
                    sortable: true,
                    className: 'min-w-90px',
                    render: function (data, type, row) {
                        return `<span data-bs-toggle="tooltip" data-bs-placement="bottom" title="${row['timezone']}">${row['time']}</span>`;
                    }
                },
                {
                    data: 'type',
                    title: 'Threat type',
                    sortable: false,
                    className: 'min-w-90px',
                    render: function (data, type, row) {
                        return row['type'];
                    }
                }
            ]
        }).on('draw', function () {
            if(datatable.page.info().recordsTotal === 0){
                $('#threat-blocker-datatable_wrapper').hide();
                $('#threat-blocker-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            } else {
                $('#threat-blocker-datatable_wrapper').show();
                $('#threat-blocker-datatable_no-results').addClass('d-none').removeClass('d-flex flex-center flex-column');
            }
        });
        // Init and add delay to datatable search
        new DatatableSearchDelay(datatable, '[data-kt-docs-table-filter=search]');
        return datatable;
    }
    filterActions(){
        this.initSelect2();
        this.initDateTimePicker();
        this.resetFilters();

        const thisClass = this;
        const filterButton = document.querySelector('[data-kt-docs-table-filter="filter"]');
        if(filterButton){
            filterButton.addEventListener('click', function () {
                thisClass.applyFilter();
            });
        }
    }
    initSelect2(){
        // Format Member options
        const tagFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            span.innerHTML = item.text;
            return $(span);
        }
        // Format Member results
        const optionFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            let template = '';
            template += '<div class="d-flex align-items-center">';
            template += item.element.getAttribute('data-kt-rich-content-avatar');
            template += '<div class="d-flex flex-column">'
            template += '<span class="fs-6 fw-bold lh-1 text-primary">' + item.text + item.element.getAttribute('data-kt-rich-content-badges') +'</span>';
            template += '<span class="fw-semibold ga-text-primary-800 fs-8">' + item.element.getAttribute('data-kt-rich-content-subcontent') + '</span>';
            template += '</div>';
            template += '</div>';
            span.innerHTML = template;
            return $(span);
        }

        // Init Select2
        $('[data-kt-docs-table-filter=members]').select2({
            placeholder: "Select an option",
            templateSelection: tagFormat,
            templateResult: optionFormat
        });
        $('[data-kt-docs-table-filter=domains]').select2({});
    }
    initDateTimePicker(){
        let start;
        let end;
        if(this.start && this.end){
            start = moment(this.start, "YYYY-MM-DD hh:mm:ss");
            end = moment(this.end, "YYYY-MM-DD hh:mm:ss");
        } else {
            start = moment().startOf('isoWeek');
            end = moment().endOf('isoWeek');
        }

        const dateEl = $("[data-kt-docs-table-filter=date]");

        function formatDate(start, end) {
            dateEl.html(start.format("MMM D, YYYY") + " - " + end.format("MMM D, YYYY"));
        }

        dateEl.daterangepicker({
            startDate: start,
            endDate: end,
            locale: {
                format: "MMM D, YYYY"
            },
            ranges: {
                "Today": [moment(), moment()],
                "Yesterday": [moment().subtract(1, "days"), moment().subtract(1, "days")],
                "This Week": [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
                "Last Week": [moment().startOf('isoWeek').subtract(7, "days"), moment().endOf('isoWeek').subtract(7, "days")],
                "This Month": [moment().startOf("month"), moment().endOf("month")],
                "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")]
            }
        }, formatDate);
        formatDate(start, end);
    }
    resetFilters(){
        const thisClass = this;

        // Select reset button
        const resetButton = document.querySelector('[data-kt-docs-table-filter="reset"]');
        if(resetButton){
            // Reset datatable
            resetButton.addEventListener('click', function () {
                // Reset members and domains
                $('[data-kt-docs-table-filter=members]').val([]).trigger('change');
                $('[data-kt-docs-table-filter=domains]').val([]).trigger('change');
                // Reset Date filter
                const dateEl = $("[data-kt-docs-table-filter=date]");
                dateEl.data('daterangepicker').setStartDate(moment().startOf('isoWeek'));
                dateEl.data('daterangepicker').setEndDate(moment().endOf('isoWeek'));

                thisClass.applyFilter(true);
            });
        }
    }
    applyFilter(reset = false){
        let numberOfActiveFilters = 0;
        let date = document.querySelector('[data-kt-docs-table-filter="date"]');

        if(reset){
            this.datatable.columns().search('');
        } else {
            // Select filter options
            let members = $('[data-kt-docs-table-filter="members"]').select2('data');
            let membersArr = [];
            for (const i in members) {
                if (members[i].id !== '') {
                    membersArr.push(members[i].id);
                }
            }

            let domains = $('[data-kt-docs-table-filter="domains"]').select2('data');
            let domainsArr = [];
            for (const i in domains) {
                if (domains[i].id !== '') {
                    domainsArr.push(domains[i].id);
                }
            }

            this.datatable.column(0).search(JSON.stringify(membersArr));
            numberOfActiveFilters += membersArr.length;
            this.datatable.column(1).search(JSON.stringify(domainsArr));
            numberOfActiveFilters += domainsArr.length;
        }

        this.datatable.column(3).search(date.value);
        numberOfActiveFilters += 1;

        this.datatable.draw();

        $('#threatBlockerNumberOfFilters').text(numberOfActiveFilters);
    }
}
window.ThreatBlockerDatatable = ThreatBlockerDatatable;